// extracted by mini-css-extract-plugin
export var buttons = "_a6-0";
export var buttonsActive = "_a6-h";
export var cancelConfirm = "_a6-1";
export var closeButton = "_a6-2";
export var column = "_a6-3";
export var container = "_a6-4";
export var detailHeader = "_a6-6";
export var detailTitle = "_a6-7";
export var detailsContent = "_a6-5";
export var header = "_a6-8";
export var headerWithClose = "_a6-9";
export var icon = "_a6-a";
export var infoIcon = "_a6-c";
export var informationContainer = "_a6-b";
export var sideDrawer = "_a6-d";
export var sideDrawerOpen = "_a6-e";
export var stickyFooter = "_a6-f";
export var typeOption = "_a6-g";